import React from "react";

import AuthorMenu from "./AuthorMenu";
import BrandMenu from "./BrandMenu";
import LabelMenu from "./LabelMenu";
import PermissionGroupMenu from "./PermissionGroupMenu";
import UserSegmentsMenu from "./UserSegmentsMenu";
import PlacementSelectorModal from "./PlacementSelectorModal";

const relativeDates = [
  "ONE_DAY_AGO",
  "ONE_WEEK_AGO",
  "ONE_MONTH_AGO",
  "THREE_MONTHS_AGO",
  "SIX_MONTHS_AGO",
  "ONE_YEAR_AGO",
];

const menuStructure = {
  name: "root",
  subMenus: [
    {
      name: "brand",
      custom: props => <BrandMenu {...props} />,
    },
    {
      name: "author",
      custom: props => <AuthorMenu {...props} />,
    },
    {
      name: "placement",
      label: "knowledge-verification.placement",
      modal: onClose => <PlacementSelectorModal onClose={onClose} />,
    },
    {
      name: "permissionGroup",
      custom: props => <PermissionGroupMenu {...props} />,
    },
    {
      name: "userSegment",
      custom: props => <UserSegmentsMenu {...props} />,
    },
    {
      name: "origin",
      subMenus: [{ name: "origin-KNOWLEDGE_CAPTURE" }],
    },
    {
      name: "isOpenForComment",
      subMenus: [
        {
          name: "isOpenForComment-yes",
          label: "knowledge-verification.yes",
        },
        { name: "isOpenForComment-no", label: "knowledge-verification.no" },
      ],
    },
    {
      name: "label",
      custom: props => <LabelMenu {...props} />,
    },
    {
      name: "isPromoted",
      subMenus: [
        { name: "isPromoted-yes", label: "knowledge-verification.yes" },
        { name: "isPromoted-no", label: "knowledge-verification.no" },
      ],
    },
    ...["created", "updated"].map(name => ({
      name,
      subMenus: [
        {
          name: `${name}-less-than`,
          label: "knowledge-verification.filters.lessThan",
          subMenus: relativeDates.map(key => ({
            name: `${name}-LESS_THAN_${key}`,
            label: `knowledge-verification.${key}`,
          })),
        },
        {
          name: `${name}-more-than`,
          label: "knowledge-verification.filters.moreThan",
          subMenus: relativeDates.map(key => ({
            name: `${name}-MORE_THAN_${key}`,
            label: `knowledge-verification.${key}`,
          })),
        },
      ],
    })),
  ],
};

export default menuStructure;



// WEBPACK FOOTER //
// ./src/components/FilterMenu/menuStructure.js